import moment from 'moment';

export function formatDate(value) {
    let aux = moment(value, "YYYY-MM-DD");
    if(aux.isValid()){
        return aux.format("DD/MM/YYYY");
    }

    return value;
}